import { Component, inject, OnInit } from '@angular/core';
import { GenericStreamsService } from '../../service/generic-streams.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-conversations',
    standalone: false,
    templateUrl: './conversations.component.html',
    styleUrl: './conversations.component.scss'
})
export class ConversationsComponent implements OnInit {
    genStreamService = inject(GenericStreamsService);
    router = inject(Router);

    conversationCounts: any;
    genericStreams: any;
    conversationStreams: any[] = [];

    async ngOnInit() {
        this.conversationCounts = await this.genStreamService.getConversations();
        this.genericStreams = await this.genStreamService.getGenericStreams();

        for (const c of this.conversationCounts) {
            const stream = this.genericStreams.find((s: any) => s.id === c.streamTypeId);

            if (stream) {
                this.conversationStreams.push({
                    ...stream,
                    conversations: c.conversationCount,
                    lastConversation: c.lastConversation
                });
            }
        }
        console.log(this.conversationStreams)
    }

    viewStreamConversation(id: string) {
        this.router.navigate(['home', 'conversations', id])
    }
}

